module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('register-form')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d3f2ef0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountDetails/AccountDetails.vue
// module id = 159
// module chunks = 0